import { render } from "./cpt-badge.vue?vue&type=template&id=a7511442"
import script from "./cpt-badge.vue?vue&type=script&lang=js"
export * from "./cpt-badge.vue?vue&type=script&lang=js"

import "./cpt-badge.vue?vue&type=style&index=0&id=a7511442&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__